import { FC } from 'react';

const Required: FC = () => {
  return (
    <span
      className="campaignbay-text-red-500"
    >
      *
    </span>
  );
};

export default Required;